<template>
    <div class="partners">
        <div class="container">
            <div class="large-title">
                Partneraftaler
                <p>
                    Vores samarbejdspartnere tilbyder lige nu følgende kampagner:
                </p>
            </div>
            <div class="content-layout">
                <div
                    class="column column__xs single-partner"
                    v-for="partner in partners"
                    v-bind:key="partner.name"
                    v-if="partner.name === 'Samlino (billede)'"
                    @click="goToInsurancePartner(partner.name)"
                >
                    <img :src="partner.image" />
                </div>
                <div
                    class="column column__xs single-partner"
                    v-for="partner in partners"
                    v-bind:key="partner.name"
                    v-if="partner.name !== 'Samlino (billede)'"
                    @click="goToPartner(partner.name, partner.link)"
                >
                    <!--<div class="title">
                        {{ partner.type }}
                    </div>-->
                    <img :src="partner.image" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars";

    .partners {

        .container {
            padding: 70px 15px 100px 15px;
            border-top: 1px solid rgba(255, 255, 255, 0.15);

            @media screen and (max-width: $small) {
                padding: 0 15px 50px 15px;
                border: none;
            }

            .large-title {
                font-size: 24px;
                color: #fff;
                text-align: center;
                font-weight: 600;
                margin-bottom: 50px;

                p {
                    margin-top: 15px;
                    font-size: 14px;
                    font-weight: 400;
                }
            }

            .single-partner {

                .title {
                    color: #fff;
                    text-align: center;
                    margin-bottom: 15px;
                    font-size: 20px;
                    font-weight: 400;
                }

                img {
                    width: 100%;
                    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                    border-radius: 10px;
                    cursor: pointer;
                    transition: .3s ease all;

                    &:hover {
                        transform: translateY(-4px);
                    }
                }
            }
        }
    }

</style>

<script>
import axios from 'axios'

export default {
    data () {
        return {
            partners: [
                /* {
                    name: 'Find Forsikring (billede)',
                    type: 'Forsikring',
                    link: 'https://www.partner-ads.com/dk/klikbanner.php?partnerid=28784&bannerid=60068&htmlurl=https://www.findforsikring.dk/indhent-tilbud-mini/?bil1=on',
                    image: '/static/partners/findforsikring-400x400.png',
                    partner: 'Partner Ads'
                }, */
                {
                    name: 'Samlino (billede)',
                    type: 'Forsikring',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino',
                    image: '/static/partners/samlino-500x500.jpg',
                    partner: 'AdService'
                },
                /* {
                    name: 'Autolånet (billede)',
                    type: 'Lån',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?bid=1342763&media_id=83530',
                    image: '/static/partners/autolaanet-600x600.jpeg',
                    partner: 'AdService'
                }, */
                /* {
                    name: 'Leo Vegas (billede)',
                    type: 'Casino',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7474&productGroup=leovegas',
                    image: '/static/partners/leovegas-square.jpg',
                    partner: 'AdService'
                }, */
                {
                    name: 'Bil Magasinet (billede)',
                    type: 'Magasin',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=10416&productGroup=banner&media_id=83530',
                    image: '/static/partners/bilm.jpeg',
                    partner: 'AdService'
                },
                /* {
                    name: 'CBB konkurrence (billede)',
                    type: 'Konkurrence',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9894&productGroup=Vind iphone XS',
                    image: '/static/partners/cbb-square.jpeg',
                    partner: 'AdService'
                } */
                {
                    name: 'One2Move (billede)',
                    type: 'Biludlejning',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=5719&productGroup=Biludlejning',
                    image: '/static/partners/one2move-400x400.jpg',
                    partner: 'AdService'
                },
                /* {
                    name: 'Shell (billede)',
                    type: 'Brændstof',
                    link: 'http://online.digital-advisor.com/SH4Ae',
                    image: '/static/partners/shell-400x400.jpg',
                    partner: 'Digital Advisor'
                } */
                /* {
                    name: 'Autobutler (billede)',
                    type: 'Reparation',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?bid=1342766&media_id=83530',
                    image: '/static/partners/autobutler-500x500.png',
                    partner: 'AdService'
                }, */
                {
                    name: 'Fastspeed (billede)',
                    type: 'Bredbånd',
                    link: 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=9581&productGroup=Fastspeed&media_id=83530',
                    image: '/static/partners/fastspeed_square.png',
                    partner: 'AdService'
                }
            ]
        }
    },
    methods: {
        goToPartner (name, link) {
            if (process.env.NODE_ENV === 'production') {
                let formattedText = ':male-detective: Affiliate klik på *' + name + '*'
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        },
        goToInsurancePartner (name) {
            let numberplate = this.$store.state.licenseplate.split(' ').join('').toUpperCase()
            // let link = 'https://ad.doubleclick.net/ddm/trackclk/N861970.2126501SAMLINO.DK/B22969279.250543226;dc_trk_aid=446948115;dc_trk_cid=118543082?https://www.samlino.dk/bilforsikring/indhentpriser?knowLicensePlateNum=true&licensePlateNumUq=' + numberplate + '&utm_source=nrpladetjek&utm_medium=cpc&utm_campaign=ciweek28_19'
            let link = 'https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino&media_id=83530'
            if (process.env.NODE_ENV === 'production') {
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Samlino')
                    }
                }
                let formattedText = ':male-detective: Affiliate klik på *' + name + '* med nrplade: ' + numberplate
                axios.post('https://hooks.slack.com/services/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', {
                    username: 'NrPladeTjek.dk',
                    icon_url: 'https://nrpladetjek.dk/static/apple-icon.png',
                    text: formattedText
                    },
                    {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                if ('ga' in window) {
                    let tracker = window.ga.getAll()[0]
                    if (tracker) {
                        tracker.send('event', 'Affiliate', 'Klik', name)
                    }
                }
            }
            window.open(link, '_blank')
        }
    }
}
</script>



// WEBPACK FOOTER //
// partners.vue?66e805c0